import { render } from "./ThoughtBubble.vue?vue&type=template&id=a9adf908&scoped=true"
import script from "./ThoughtBubble.vue?vue&type=script&lang=js"
export * from "./ThoughtBubble.vue?vue&type=script&lang=js"

import "./ThoughtBubble.vue?vue&type=style&index=0&id=a9adf908&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9adf908"]])

export default __exports__